<template>
    <div></div>
</template>
<script setup>
import { onBeforeMount, ref } from 'vue'
import { useRouter } from 'vue-router';
import opmStore from '@/lib/storeOwnerProjectManager';
const router = useRouter();

const primaryNav = ref([]);

onBeforeMount(async() => {
    await opmStore.dispatch('getUserChrome');
    primaryNav.value = opmStore.state.chrome.primaryNav;
    router.push({ 
        path: primaryNav.value[0].url
    });
})
</script>